import React, { lazy } from 'react';
import IconANR from '@/assets/images/menu/icon-anr.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const anrHarmonyRoutes = (): IRouteConfig[] => [
  {
    path: '/exception/anr',
    name: 'FREEZE',
    icon: <MenuIcon icon={IconANR} />,
    sort: 98,
    platforms: [
      CapitalPlatform.HarmonyOS,
    ],
    routes: [
      // for 鸿蒙
      {
        path: '/exception/anr/dashboard',
        name: '概览',
        component: lazy(() => import('@/presentation/pages/anr/dashboard')),
      },
      {
        path: '/exception/anr/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/anr/issues-android/list')),
      },
      {
        path: '/exception/anr/drop-frame/detail',
        name: '关联卡顿详情',
        component: lazy(() => import('@/presentation/pages/anr/issues-android/drop-frame/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/anr/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/anr/issues-android/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/anr/caller/detail',
        name: '调用方详情',
        component: lazy(() => import('@/presentation/pages/anr/caller-detail')),
        hideInMenu: true,
        whitelisted: true,
      },
    ],
  },
];

export default anrHarmonyRoutes;
